The identifier for the unposted `PositionProfile`.
